import { connect } from 'react-redux';
import { Spinner } from '@fluentui/react-components';
import { CheckmarkCircle16Regular, Warning16Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

// component functions
import * as ComponentFunctions from './StageFix.Form.Item.Functions';
import { isStageLinked } from '../StageFix.Form.Logic';

// models
import { ProtocolVisit } from '../../../../../models/Entities/Protocols/ProtocolVisit';
import { ContractStage } from '../../../../../models/Entities/Contracts/ContractStage';

// components
import ProtocolVisitSelectorComponent from '../../../../../commons/component/Inputs/ProtocolVisitsSelector/ProtocolVisitSelector.Component';

import './StageFix.Form.Item.Styles.css';

/** Una etapa del contrato y la visita del flowchart que le responde. */
const StageFormItemComponent = (props: ComponentFunctions.Props) => {
    const { t } = useTranslation();

    const onChangeVisit = (contractVisit: ContractStage, crossVersionId: number) => {
        if (contractVisit) {
            // visits-full no trae la adenda de la etapa: viene resuelta desde el contrato.
            const addendumId = props.AddendumId ?? contractVisit.contractAddendumId;
            props.LinkStageToAProtocolVisit(props.ProtocolId, contractVisit.contractId, addendumId, contractVisit.id, crossVersionId);
        }
    }

    if (!props.Stage) {
        return null;
    }

    const linked = isStageLinked(props.Stage);

    return (
        <div className={`sfx-row${linked ? ' sfx-row--linked' : ' sfx-row--unlinked'}`}>
            <span className="sfx-row__order" aria-label={t('stageFixFormItem.stageOrder', { order: props.Stage.stageOrder, defaultValue: 'Etapa {{order}}' })}>
                {props.Stage.stageOrder}
            </span>
            <div className="sfx-row__body">
                <div className="sfx-row__head">
                    <span className="sfx-row__name" title={props.Stage.stageName}>{props.Stage.stageName}</span>
                    {props.isLinkingStage ? (
                        <span className="sfx-muted sfx-row__state"><Spinner size="extra-tiny" /> Guardando…</span>
                    ) : props.failOnLinkingStage ? (
                        <span className="sfx-tag sfx-tag--bad"><Warning16Regular /> No se pudo asociar</span>
                    ) : linked ? (
                        <span className="sfx-tag sfx-tag--ok"><CheckmarkCircle16Regular /> Asociada</span>
                    ) : (
                        <span className="sfx-tag sfx-tag--warn">Sin visita</span>
                    )}
                </div>
                <div className="sfx-row__picker">
                    {props.ProtocolId && <ProtocolVisitSelectorComponent
                        ProtocolId={props.ProtocolId}
                        onSelectedVisit={(visit: ProtocolVisit[] | ProtocolVisit | undefined) => onChangeVisit(props.Stage, (visit as ProtocolVisit)?.crossVersionId)}
                        SelectedVisitIds={props.Stage.emrProtocolVisitIdRelated ? [props.Stage.emrProtocolVisitIdRelated] : undefined}
                        ExcludedVisitIds={props.ExcludedVisitIds || []}
                        MultiselectEnable={false}
                    />}
                </div>
            </div>
        </div>
    )
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(StageFormItemComponent as any);
